module.exports = __webpack_public_path__ + "static/media/covers3.516473b4.png";